import React, { useMemo } from 'react';
import { Text } from '@fragments';
import { IconSparkles } from '@tabler/icons-react';
import { ArtPreview, layerBox, pageOf } from '../../../../features/ArtEditor';
import { withChoice } from '../../format';
import './styles.scss';

// The place's page in the draft (`preview`), with the choice already in it, and the place
// outlined: the layer it fills, or the whole page for a background. A place to generate
// keeps the draft's image under the AI mark until the image exists.
export default function PlacePreview({ t, draft, place, choice }) {
  const doc = useMemo(() => withChoice(draft, place, choice), [draft, place, choice]);
  if (!doc) return null;
  const page = pageOf(doc, place.page_id);
  const layer = place.layer_id ? page.layers.find(item => item.id === place.layer_id) : null;
  const box = layer ? layerBox(layer) : { x: 0, y: 0, width: doc.width, height: doc.height, rotation: 0 };
  const percent = (value, total) => `${(value / total) * 100}%`;
  return <div className="studio-image-place">
    <div className="studio-image-place__page">
      <ArtPreview document={doc} pageId={page.id} label={t('imagesPreviewLabel', { number: place.page })} />
      <span className={`studio-image-place__box ${layer ? '' : 'is-page'}`} aria-hidden="true" style={{ left: percent(box.x, doc.width), top: percent(box.y, doc.height),
        width: percent(box.width, doc.width), height: percent(box.height, doc.height), transform: box.rotation ? `rotate(${box.rotation}deg)` : undefined }}>
        {choice?.source === 'generate' && <span className="studio-image-place__ai"><IconSparkles /><Text.caption>{t('imagesAiMark')}</Text.caption></span>}
      </span>
    </div>
    <Text.caption contrast={6}>{t('imagesPreviewCaption', { number: place.page, total: doc.pages.length })}</Text.caption>
  </div>;
}
